import React, { useState } from 'react';
import { Stack, Typography, Box, Button, Avatar } from '@mui/material';
import { AppColors } from '../../../Utils/helper/AppColors';
import { DotIcon, PlayCircleIcon } from '../../../Components/Icons/Icons';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { PATH_NAME } from '../../../Routes/Pathname';
import PlayingModal from '../../Recordings/Components/PlayingModal';
import recordIcon from '../../../Assets/Icons/record.svg';
import DataNotFound from '../../../Components/DataNotFound';
import { getColorSettings } from '../../../Utils/helper/commonUtils';

export default function ConversationList({ heading, data = [], line, firstIcon }) {
	const navigate = useNavigate();

	console.log('data', data);

	const [showAll, setShowAll] = useState(false); // State to toggle "Show More"
	// data = [
	// 	{
	// 		conversation: 'This is a sample conversation text.This is a sample conversation text.This is a sample conversation text.',
	// 		name: 'John Doe',
	// 		date: 'May 13, 2025',
	// 	},
	// 	{ conversation: 'Another conversation with more details.', name: 'Jane Smith', date: 'May 12, 2025' },
	// 	{ conversation: 'A third conversation for testing.', name: 'Alice Johnson', date: 'May 11, 2025' },
	// 	{ conversation: 'A third conversation for testing.', name: 'Alice Johnson', date: 'May 11, 2025' },

	// 	{ conversation: 'A third conversation for testing.', name: 'Alice Johnson', date: 'May 11, 2025' },
	// 	{
	// 		conversation: 'This is a sample conversation text.This is a sample conversation text.This is a sample conversation text.',
	// 		name: 'John Doe',
	// 		date: 'May 13, 2025',
	// 	},
	// 	{ conversation: 'Another conversation with more details.', name: 'Jane Smith', date: 'May 12, 2025' },
	// 	{ conversation: 'A third conversation for testing.', name: 'Alice Johnson', date: 'May 11, 2025' },
	// 	{ conversation: 'A third conversation for testing.', name: 'Alice Johnson', date: 'May 11, 2025' },

	// 	{ conversation: 'A third conversation for testing.', name: 'Alice Johnson', date: 'May 11, 2025' },
	// ];
	const [selected, setSelected] = useState(null);

	const visibleData = true;

	const localSettingColors = getColorSettings();

	return (
		<Stack
			spacing={2}
			sx={{
				height: '100%', // Ensure parent provides height too!
				border: `1px solid ${AppColors.WHITE}`,
				borderRadius: '10px',
				backgroundColor: AppColors.WHITE,
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<Stack sx={{ padding: '10px 16px', borderBottom: '1px solid #f0f0f0' }}>
				{/* Heading */}
				<Typography
					sx={{
						fontWeight: 600,
						fontFamily: 'Poppins',
						fontSize: 18,
						lineHeight: '150%',
						color: AppColors.HEADING_TITLE,
					}}
				>
					{heading}
				</Typography>
			</Stack>

			{/* Scrollable Content */}

			{data.length === 0 ? (
				<DataNotFound size={120} />
			) : (
				<>
					<Box
						sx={{
							overflowY: 'auto',
							padding: '0px 16px 0px 16px',
							// border : '1px solid red'
						}}
					>
						{data.map((item, index) => (
							<Box
								key={index}
								sx={{
									borderBottom: '1px solid #f0f0f0',
									paddingBottom: 1,
									marginBottom: 1,
									display: 'flex',
									flexDirection: 'row',
									gap: 1,
								}}
							>
								{/* Icon */}
								{/* <Stack sx={{  justifyContent: 'start', alignItems: 'center' }}> */}
								{firstIcon ? (
									<Avatar
										sx={(theme) => ({
											height: 26,
											width: 26,
											color: theme.palette.primary_shade,
											borderRadius: 0,
											cursor: 'pointer',
										})}
										src={recordIcon}
										onClick={() => setSelected(item)}
									/>
								) : (
									<PlayCircleIcon color={localSettingColors.fontColor} size={26} onClick={() => setSelected(item)} />
								)}
								{/* </Stack> */}

								{/* Conversation Details */}
								<Stack sx={{ flex: 1 }}>
									<Typography
										sx={{
											display: '-webkit-box',
											WebkitBoxOrient: 'vertical',
											WebkitLineClamp: line ? line : 2,
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											fontFamily: 'Poppins',
											fontWeight: 400,
											fontSize: '14px',
											lineHeight: '121%',
											paddingRight: '20px',
										}}
									>
										{item?.callSummary?.summary}
									</Typography>

									<Stack direction={'row'} justifyContent={'space-between'} mt={1}>
										<Typography
											sx={{
												fontFamily: 'Poppins',
												fontSize: '12px',
												fontWeight: 500,
												lineHeight: '121%',
												color: AppColors.HEADING_TITLE4,
											}}
										>
											{item?.name}
										</Typography>
										<Typography
											sx={{
												fontFamily: 'Poppins',
												fontSize: '12px',
												fontWeight: 500,
												lineHeight: '121%',
												color: AppColors.HEADING_TITLE4,
											}}
										>
											{dayjs(item?.call?.startedAt).format('MMM DD, YYYY')}
										</Typography>
									</Stack>
								</Stack>
							</Box>
						))}
					</Box>

					<Stack sx={{ padding: '0px 16px 10px 16px' }}>
						{visibleData && (
							<Typography
								onClick={() => navigate(PATH_NAME.CONVERSATIONS)}
								sx={(theme) => ({
									fontFamily: 'Poppins',
									fontSize: '14px',
									fontWeight: 500,
									lineHeight: '121%',
									color: theme.palette.primary.primary_shade,
									alignSelf: 'start',
									cursor: 'pointer',
								})}
							>
								{'Show More'}
							</Typography>
						)}
					</Stack>

					{/* Show More Button */}
				</>
			)}

			<PlayingModal open={Boolean(selected)} onClose={() => setSelected(null)} selected={selected} />
		</Stack>
	);
}
